import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface CustomerLinkProps {
  readonly customerId: string;
  readonly label: string;
  readonly className?: string;
  readonly ariaLabel?: string;
}

/**
 * Teal hyperlink that drills through to a Customer Detail page.
 * Stops click/keyboard propagation so it never triggers a parent row handler
 * (e.g. opening the contact side panel).
 */
export function CustomerLink({ customerId, label, className, ariaLabel }: CustomerLinkProps) {
  return (
    <Link
      to={`/customers/${customerId}`}
      aria-label={ariaLabel ?? `View customer ${label}`}
      className={cn('text-teal-600 hover:text-teal-700 hover:underline focus-visible:underline', className)}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.stopPropagation();
        }
      }}
    >
      {label}
    </Link>
  );
}
